import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  padding: 16px 20px;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 26px;\n\n  p {\n    align-items: center;\n    display: flex;\n\n    i {\n      margin-right: 12px;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  padding: 12px 20px 20px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  padding: 16px 20px;\n  display: flex;\n  justify-content: space-between;\n  color: ",
        ";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.5;\n  letter-spacing: -0.16px;\n  cursor: pointer;\n  word-break: break-word;\n  align-items: center;\n\n  i {\n    margin-left: 20px;\n  }\n\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  /* margin-top: 24px; */\n  height: 100%;\n  margin: 0;\n\n  &.depth-two-container {\n    height: calc(100vh - 58px);\n    max-height: calc(var(--svh, 1svh) * 100 - 58px);\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.14px;\n  padding: 0 20px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  width: 100%;\n  gap: 8px;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  border: 1px solid ",
        ";\n  border-radius: 6px;\n  padding: 8px 16px;\n  width: 100%;\n  align-items: center;\n  flex-direction: column;\n  gap: 2px;\n  justify-content: center;\n\n  text-align: center;\n\n  :hover {\n    color: unset;\n  }\n\n  p {\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: 600;\n    letter-spacing: -0.14px;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 8px;\n\n  > button {\n    width: 100%;\n    padding: 12px 20px;\n    font-size: 16px;\n    line-height: 1.5;\n    transition: all 0.3s;\n\n    :first-child {\n      border: 1px solid ",
        ";\n\n      :hover {\n        color: unset;\n        background-color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _tagged_template_literal([
        "\n  //position: sticky;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  bottom: 0;\n  margin-top: 80px;\n  border: none;\n  text-align: left;\n  padding: 13px 20px;\n  height: 48px;\n  color: ",
        ";\n  line-height: 22px; /* 157.143% */\n  border-top: 1px solid ",
        ";\n\n  i {\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _tagged_template_literal([
        "\n  border-radius: 6px;\n  justify-content: space-between;\n  margin-bottom: 0;\n  padding: 9px 16px;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _tagged_template_literal([
        "\n  height: 100vh;\n  height: calc(var(--vh, 1vh) * 100);\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = _tagged_template_literal([
        "\n  margin: 0;\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useRedirect, { REDIRECT_QUERY } from "@/hooks/useRedirect";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { LIBRARIES_INDEX_PAGE, LOGIN_PAGE, MYPAGE_PASSES, PASSES_LANDING, REGISTRATION_PAGE, SOLVOOK_WRITE_STUDIO } from "@/settings/constant";
import { Button as SolvookButton } from "@bookips/solvook-ui-library";
import { Button, Divider } from "antd";
import Link from "next/link";
import { useRouter } from "next/router";
import styled, { useTheme } from "styled-components";
import { useTooltip } from "../common/GNB/useTooltip";
import Icon from "../icon/Icon";
import { ArrowLeft, ArrowRight, Close1_5px, Library, Sizes, Studio, User } from "../icon/IconList";
import { MembershipStatusLinkWrapper } from "../Landing/PassPromotion";
export const SideSheetHeader = (param)=>{
    let { title , onClose , currentStep , goToPrevStep  } = param;
    const theme = useTheme();
    return /*#__PURE__*/ _jsxs(SideSheetHeaderContainer, {
        children: [
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    !!goToPrevStep && /*#__PURE__*/ _jsx(Icon, {
                        onClick: goToPrevStep,
                        icon: ArrowLeft,
                        size: Sizes.xmedium,
                        color: theme.new.colors.sol_gray_900
                    }),
                    title
                ]
            }),
            /*#__PURE__*/ _jsx(Icon, {
                className: "close-btn",
                onClick: onClose,
                icon: Close1_5px,
                size: Sizes.xmedium,
                color: theme.new.colors.sol_gray_900
            })
        ]
    });
};
export const SideSheetHeaderContainer = styled.div.withConfig({
    componentId: "sc-606e4a5b-0"
})(_templateObject());
export const SideSheetUtils = ()=>{
    const { isLoggedIn  } = useAuthStore();
    const theme = useTheme();
    return /*#__PURE__*/ _jsxs(SideSheetUtilContainer, {
        children: [
            isLoggedIn ? /*#__PURE__*/ _jsx(LoginMenu, {}) : /*#__PURE__*/ _jsx(LogoutMenu, {}),
            /*#__PURE__*/ _jsxs(SideSheetPromotionLink, {
                href: PASSES_LANDING,
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        children: "이용권 구매하기"
                    }),
                    /*#__PURE__*/ _jsx(Icon, {
                        icon: ArrowRight,
                        size: Sizes.small,
                        color: theme.new.colors.sol_indigo_500
                    })
                ]
            })
        ]
    });
};
export const SideSheetUtilContainer = styled.div.withConfig({
    componentId: "sc-606e4a5b-1"
})(_templateObject1());
const LogoutMenu = ()=>{
    const router = useRouter();
    const currentPathname = router.asPath;
    const { redirectToLogin  } = useRedirect();
    const sideSheetMixpanel = (name, link, type)=>{
        mixpanelEvent("Side Sheets Button Clicked", {
            "Button Type": type,
            "Button Name": name,
            "Button Url": link
        });
    };
    return /*#__PURE__*/ _jsxs(LogoutMenuWrapper, {
        children: [
            /*#__PURE__*/ _jsx(SolvookButton, {
                variant: "strokeSecondary",
                onClick: ()=>{
                    sideSheetMixpanel("login", LOGIN_PAGE, "로그인");
                    redirectToLogin();
                },
                label: "로그인"
            }),
            /*#__PURE__*/ _jsx(SolvookButton, {
                variant: "soft",
                onClick: ()=>{
                    sideSheetMixpanel("signup", REGISTRATION_PAGE, "회원가입");
                    router.push({
                        pathname: "".concat(REGISTRATION_PAGE),
                        query: currentPathname.length > 1 && {
                            [REDIRECT_QUERY]: currentPathname
                        }
                    });
                },
                label: "회원가입"
            })
        ]
    });
};
const LoginMenu = ()=>{
    const theme = useTheme();
    const loginMenu = [
        {
            title: "자료 보관함",
            icon: Library,
            link: LIBRARIES_INDEX_PAGE,
            type: "library"
        },
        {
            title: "엑스퍼트",
            icon: Studio,
            link: SOLVOOK_WRITE_STUDIO,
            type: "expert"
        },
        {
            title: "마이페이지",
            icon: User,
            link: MYPAGE_PASSES,
            type: "mypage"
        }
    ];
    const { isTooltipVisible , handleTooltip  } = useTooltip({
        cookieName: "expertTooltip",
        day: 1
    });
    return /*#__PURE__*/ _jsx(LoginMenuContainer, {
        children: loginMenu.map((menu, index)=>{
            return /*#__PURE__*/ _jsxs(SideSheetMenuLink, {
                href: menu.link,
                onClick: ()=>{
                    mixpanelEvent("Side Sheets Button Clicked", {
                        "Button Type": menu.type,
                        "Button Name": menu.title,
                        "Button Url": menu.link
                    });
                    if (menu.type === "expert") handleTooltip();
                },
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        icon: menu.icon,
                        size: Sizes.medium,
                        color: theme.new.colors.sol_gray_700
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: menu.title
                    })
                ]
            }, index);
        })
    });
};
export const MenuListItem = (param)=>{
    let { label , onClick  } = param;
    return /*#__PURE__*/ _jsxs(MenuListItemContainer, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ _jsx("p", {
                children: label
            }),
            /*#__PURE__*/ _jsx(Icon, {
                icon: ArrowRight,
                size: Sizes.xmedium
            })
        ]
    });
};
export const MenuListItemContainer = styled.li.withConfig({
    componentId: "sc-606e4a5b-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_700, (props)=>props.theme.new.colors.sol_gray_700);
export const MenuListContainer = styled.div.withConfig({
    componentId: "sc-606e4a5b-3"
})(_templateObject3());
export const MenuListTitle = styled.p.withConfig({
    componentId: "sc-606e4a5b-4"
})(_templateObject4(), (props)=>props.theme.new.colors.sol_gray_300);
const LoginMenuContainer = styled.div.withConfig({
    componentId: "sc-606e4a5b-5"
})(_templateObject5());
const SideSheetMenuLink = styled(Link).withConfig({
    componentId: "sc-606e4a5b-6"
})(_templateObject6(), (props)=>props.theme.new.colors.sol_gray_100);
export const LogoutMenuWrapper = styled.div.withConfig({
    componentId: "sc-606e4a5b-7"
})(_templateObject7(), (props)=>props.theme.new.colors.sol_gray_100, (props)=>props.theme.new.colors.sol_gray_100);
export const LogoutButton = styled(Button).withConfig({
    componentId: "sc-606e4a5b-8"
})(_templateObject8(), (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_gray_100);
export const SideSheetPromotionLink = styled(MembershipStatusLinkWrapper).withConfig({
    componentId: "sc-606e4a5b-9"
})(_templateObject9());
export const SideSheetContentsContainer = styled.div.withConfig({
    componentId: "sc-606e4a5b-10"
})(_templateObject10());
export const StepDivider = styled(Divider).withConfig({
    componentId: "sc-606e4a5b-11"
})(_templateObject11());
